import React from 'react';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const StartActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <PlayArrowIcon />
    </BaseActionButton>
  );
};

export default StartActionButton;
